<template>
  <div class="mpu__wrapper my-4">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="300" height="250">
      <v-card-text class="text-center text-overline accent--text">MPU<br><!-- 300 x 250<br> -->{{ adUnitId }}</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'MPU',

    props: {
      adUnitId: {
        type: String,
        default: ''
      }
    }
  }
</script>